import React, { SetStateAction } from 'react';
import {
	Grid,
} from 'antd';
import CargoDetails, { ModalModes } from '@client/screens/cargos/details/CargoDetailsScreen';
import { useCentralStore } from '@client/screens/estimates/details/context/CentralStoreContext';
import { useNavigationBlock } from '@client/lib/navigationBlock';
import Modal from '@client/components/Modal/Modal';
import styles from './CargoDetailsModal.module.css';

type Props = {
	mode: ModalModes;
	cargoId: number | null;
	visible: boolean;
	refresh?: () => Promise<void>;
	setEditingCargoId: React.Dispatch<SetStateAction<number | null>>;
	isTceLocked?: boolean;
	updateInProgress?: boolean;
	creatingCargo?: boolean;
	voyageId?: number;
	onClose?: () => void;
	onCargoCreation?: () => void;
	inEstimate?: boolean;
	selectedCargoPortId?: number | null;
};

const CargoDetailsModal = ({
	mode,
	cargoId,
	visible,
	refresh,
	setEditingCargoId,
	isTceLocked,
	voyageId,
	onClose,
	onCargoCreation,
	selectedCargoPortId,
}: Props) => {
	const [blockClose, setBlockClose] = React.useState(false);
	const screens = Grid.useBreakpoint();

	const closeModal = async () => {
		onClose?.();
		await refresh?.();
		setEditingCargoId?.(null);
	};

	const {
		selectedEstimateId,
		estimate,
	} = useCentralStore();

	const {
		useBlocker,
		makeBlockable,
	} = useNavigationBlock();

	useBlocker(blockClose);

	const onCloseModal = makeBlockable(closeModal);

	return (
		<Modal
			closable={false}
			open={visible}
			onCancel={onCloseModal}
			destroyOnClose
			width={`calc(100vw - ${screens.lg ? '15%' : '5%'})`}
			className={styles.modal}
			okText="Close"
			okButtonProps={{
				onClick: () => onCloseModal(),
			}}
			cancelButtonProps={{
				style: {
					visibility: 'hidden',
				},
			}}
		>
			{(cargoId != null || visible) && (
				<CargoDetails
					mode={mode}
					onCargoCreation={onCargoCreation}
					cargoId={cargoId ?? undefined}
					isTceLocked={isTceLocked}
					selectedEstimateId={selectedEstimateId ?? undefined}
					blockClose={blockClose}
					setBlockClose={setBlockClose}
					estimate={estimate}
					voyageId={voyageId}
					selectedCargoPortId={selectedCargoPortId}
				/>
			)}
		</Modal>
	);
};

export default CargoDetailsModal;
